import Winter2023X2 from './Winter2023X2';

export default Winter2023X2;
